import { createSlice } from '@reduxjs/toolkit';

import { MODAL_KEYS } from '_constants/modals';

const initialState = {
  visibility: {
    [MODAL_KEYS.paymentMethodAdd]: false,
    [MODAL_KEYS.cancelSubscriptionConfirm]: false,
  },
  data: {
    [MODAL_KEYS.paymentMethodAdd]: {},
    [MODAL_KEYS.cancelSubscriptionConfirm]: {},
  },
};

const modalsSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    showModal(state, action) {
      state.visibility = {
        ...state.visibility,
        [action.payload.key]: true,
      };

      state.data = {
        ...state.data,
        [action.payload.key]: action.payload.data || {},
      };
    },
    hideModal(state, action) {
      state.visibility = {
        ...state.visibility,
        [action.payload.key]: false,
      };

      state.data = {
        ...state.data,
        [action.payload.key]: action.payload.data || {},
      };
    },
    resetModals(state) {
      state.visibility = initialState.visibility;
      state.data = initialState.data;
    },
  },
});

export const { showModal, hideModal, resetModals } = modalsSlice.actions;

export default modalsSlice.reducer;
